import { useCallback } from 'react';
import { useInternalRegulationObligationRulesQuery } from '../graphql/queries/internalRegulationObligationRules.generated';
import { createObligationIdFilter } from './filterConstants';

const PAGE_SIZE = 25;

export const useObligationRules = (obligationId?: string) => {
  const { data, loading, error, fetchMore } = useInternalRegulationObligationRulesQuery({
    variables: {
      first: PAGE_SIZE,
      input: {
        filters: {
          groups: obligationId ? [createObligationIdFilter(obligationId)] : [],
        },
      },
    },
    notifyOnNetworkStatusChange: true,
    skip: !obligationId,
  });

  const pageInfo = data?.internalRegulationObligationRules?.pageInfo;

  const handleFetchMore = useCallback(() => {
    if (pageInfo?.hasNextPage && !loading) {
      fetchMore({
        variables: {
          after: pageInfo.endCursor,
        },
      });
    }
  }, [pageInfo, loading, fetchMore]);

  const rules = data?.internalRegulationObligationRules?.edges.map((edge) => edge.node) ?? [];

  return { rules, loading, error, pageInfo, handleFetchMore };
};
